import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie';
import {getIdentityType} from '@/utils/auth'
//webpack热加载在开发环境下会很慢，因此只在生产环境下进行懒加载
// const _import = require('./_import_' + process.env.NODE_ENV);
// const Login = _import('login/login');
const Login = ()=> import('../views/login/login')
import Home from '@/views/Orgin/Home';
import ProjectManag from '@/views/Orgin/ProjectManag/ProjectManag'; // 项目管理--项目管理
import ProjectDetail from "@/views/Orgin/ProjectManag/Detail/ProjectDetail"; // 项目管理--项目管理-项目详情
import ProjectHistory from "@/views/Orgin/ProjectManag/History/ProjectHistory";// 项目管理--项目管理-项目详情-项目历史
import ProjectReport from "@/views/Orgin/ProjectManag/Report/ProjectReport";// 项目管理--项目管理-项目详情-生成报告
import Report from "@/views/Orgin/ProjectManag/Report/Report";// 项目管理--项目管理-项目详情-生成报告
import ChecklistEdit from "@/views/Orgin/ProjectManag/Edit/ChecklistEdit"; //项目管理--项目管理-项目详情-检查表编辑
import Expert from "@/views/Orgin/PersonManag/Expert"; // 人员管理--专家列表
import ProAdministrator from "@/views/Orgin/PersonManag/ProAdministrator"; // 人员管理--项目管理员列表
import ProjectEval from "@/views/Expert/ProjectEval"// 专家登录--项目评估
import GoingProject from "@/views/Expert/GoingProject/GoingProject"; // 项目评估--进行中项目
import GoingProDetail from "@/views/Expert/GoingProject/GoingProDetail"; // 项目评估--进行中项目-项目详情
import CompleteProject from "@/views/Expert/CompleteProject/CompleteProject"; // 项目评估--已完成项目
import CompleteProDetail from "@/views/Expert/CompleteProject/CompleteProDetail"; // 项目评估--已完成项目-项目详情
// import ProjectManag from "@/views/projectManag/projectManag"
// import HelloWorld from '@/views/HelloWorld'
// import menuList from '@/views/menuList'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    { 
      path: '/',
      redirect: getIdentityType() == "1" ? '/projectManag':'/projectEval',
      hidden: true 
    },
    { 
      path: '/login',
      component: Login,
      hidden: true 
    },
    { 
      path: '/report/:id',
      component: Report,
      hidden: true 
    },
    // 机构管理员登录
    {
      path: '/projectManag', // 项目管理
      name: 'Home',
      component: Home,
      meta:{title:'项目管理'},
      redirect:'/projectManag/ProjectManag',
      children:[
        {
          path:"ProjectManag",
          name:"ProjectManag",
          component:ProjectManag,
          meta:{title:"项目管理"}
        },
        {
          path:"ProjectDetail/:id",
          name:"ProjectDetail",
          component:ProjectDetail,
          meta:{title:"项目详情"},
          // children:[
          //   {
          //     path:"ProjectHistory",
          //     name:"ProjectHistory",
          //     component:ProjectHistory,
          //     meta:{title:"项目历史"}
          //   },
          // ]
        },
        {
          path:"ProjectHistory/:id",
          name:"ProjectHistory",
          component:ProjectHistory,
          meta:{title:"项目历史"}
        },
        {
          path:"ProjectReport/:id",
          name:"ProjectReport",
          component:ProjectReport,
          meta:{title:"生成报告"}
        },
        {
          path:"ChecklistEdit/:id",
          name:"ChecklistEdit",
          component:ChecklistEdit,
          meta:{title:"编辑检查表"}
        },
      ]
    }, 
    {
      path: '/personManag', // 人员管理
      name: 'Home',
      component: Home,
      meta:{title:'人员管理'},
      redirect:'/personManag/ProAdministrator',
      children:[
        {
          path:"Expert",
          name:"Expert",
          component: Expert,
          meta:{title:"专家列表"}
        },
        {
          path:"ProAdministrator",
          name:"ProAdministrator",
          component:ProAdministrator,
          meta:{title:"项目管理员列表"}
        }
        
      ]
    },
    // 专家登录
    {
      path: '/projectEval', // 项目评估
      name: 'ProjectEval',
      component: Home,
      meta:{title:'项目评估'},
      redirect:'/projectEval/GoingProject',
      children:[
        {
          path:"GoingProject",
          name:"GoingProject",
          component:GoingProject,
          // component:{render(c){return c('router-view')}},
          meta:{title:"进行中项目"},
          // redirect:'/personEval/GoingProject/GoingProDetail',
          // children:[
          //   {
          //     path:"GoingProDetail",
          //     name:"GoingProDetail",
          //     component:GoingProDetail,
          //     meta:{title:'项目详情'}
          //   }
          // ]
        },
        {
          path:"CompleteProject",
          name:"CompleteProject",
          component: CompleteProject,
          meta:{title:"已完成项目"}
        },
        {
          path:"GoingProDetail/:id",
          name:"GoingProDetail",
          component:GoingProDetail,
          meta:{title:'项目详情'}
        },
        {
          path:"CompleteProDetail/:id",
          name:"CompleteProDetail",
          component:CompleteProDetail,
          meta:{title:'项目详情'}
        }
      ]
    },
  ]
})

const whiteList = ['/login']

router.beforeEach(async(to, from, next) => {
  let token = Cookies.get("token")

  if (token && token.trim().length > 0) {
    next()
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }
})

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js